import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {requestContactChange} from '../../../../redux/actions/profile';
import {
  profileChangeContactsResponseSelector,
  profileChangeContactsNewValueSelector,
} from '../../../../redux/selectors/profile';
import {RequestedOperationType, SendCodeResponsePayload} from '../../../../shared/models/api';
import View from './view';
import {initialize, reduxForm} from 'redux-form';
import {Forms} from '../../../../shared/models/forms';
import {ConfirmEmailForm} from './model';

const _EmailConfirmation: React.FC = () => {
  const dispatch = useDispatch();
  const newValue = useSelector(profileChangeContactsNewValueSelector()) as string;
  const sendCodeResponse = useSelector(profileChangeContactsResponseSelector()) as SendCodeResponsePayload;

  React.useEffect(() => {
    dispatch(initialize(Forms.confirmEmailForm, {email: newValue}));
  }, []);

  const handleResendCode = () => {
    try {
      dispatch(requestContactChange(newValue, RequestedOperationType.SetEmailConfirmation));
    } catch (err) {}
  };

  return <View onRefresh={handleResendCode} sendCodeResponse={sendCodeResponse} />;
};

export const EmailConfirmation = reduxForm<ConfirmEmailForm, {}>({
  form: Forms.confirmEmailForm,
})(_EmailConfirmation);
